import Select from "@ticketingplatform/ui/dist/components/atoms/Fields/Select";
import useMonthSelect from "hooks/useMonthSelect";
import { View } from "react-native";

import { useEventList } from "./hooks";
import EventFlatList from "./partials/EventList";

const EventList: React.FC = () => {
  const monthSelect = useMonthSelect({
    todayAsDefaultValue: true,
    preceding: 12,
  });
  const eventList = useEventList(monthSelect.value);

  return (
    <View style={{ flex: 1 }}>
      <Select {...monthSelect} />
      <EventFlatList {...eventList} />
    </View>
  );
};

export default EventList;
